module.exports = __webpack_public_path__ + "static/media/login_img@2x.62abbba6.png";